import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    rokysu: new Date().getFullYear(),
    datadagraf:[],
  /*  opozornenia:[],*/
  },
  getters: {
    rokyjes: state => state.rokysu,
    grafje: state => state.datadagraf,
   /* upozornenie: state => state.opozornenia,*/
  },
  mutations: {
    ADD_ROK:(state,rok) => {
      state.rokysu = rok
    },
    ADD_GRAF:(state,datagraf) => {
      state.datadagraf = datagraf
    },
   /* ADD_UP:(state,dataup) => {
      state.opozornenia = dataup
    }*/
  },
  actions: {

  }
});
